(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.c_feature-list');
    sections.forEach((section) => initSection(section));
  });

function initSection(section) {
  if (section.dataset.featureListInitialized === 'true') return;
  section.dataset.featureListInitialized = 'true';

  initDrawer(section);
  initAccordion(section);

  // 動的に差し替わる記事も含め、画像が取得できない場合は別画像で代替しない。
  const showMissingImage = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.closest('[data-feature-list]')) return;
    const container = image.closest('.c_article__image-container');
    if (!container) return;
    image.hidden = true;
  };
  section.addEventListener('error', (event) => showMissingImage(event.target), true);
  section.querySelectorAll('[data-feature-list] img').forEach((image) => {
    if (image.complete && image.naturalWidth === 0) showMissingImage(image);
  });

  const state = {
    cachedArticles: null,
    filteredArticles: null,
    isLoading: false,
    pendingFilter: false,
    prefersReducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)'),
    blogUrl: section.dataset.blogUrl,
    articlesCount: Number(section.dataset.articlesCount),
    perPage: Number(section.dataset.perPage),
    selectedCategory: getInitialCategory(section),
    selectedGenders: new Set(),
    selectedBrands: new Set(),
    currentPage: 1,
    section,
    list: section.querySelector('[data-feature-list]'),
    paginationContainer: section.querySelector('[data-feature-pagination]'),
  };

  initCategoryTabs(state);
  initFilterCheckboxes(state);
  initFilterClear(state);
  initPaginationDelegate(state);
  applyUrlFilter(state);
  // 初期表示でも非表示記事を除いた件数でページ分割する。
  applyFilters(state);
  const restoreUrl = () => {
    if (!section.isConnected) {
      window.removeEventListener('popstate', restoreUrl);
      return;
    }
    applyUrlFilter(state);
    applyFilters(state);
  };
  window.addEventListener('popstate', restoreUrl);
}

const GENDER_SLUG_MAP = { women: 'レディース', men: 'メンズ', kids: 'キッズ' };

// カテゴリはShopify標準のタグURL、追加条件はクエリで共有する。
function normalizeFeatureBrand(value) {
  return ['Mighty Soxer#brand', 'MightySoxer#brand', '靴下屋fam'].includes(value) ? '靴下屋fam#brand' : value;
}

function applyUrlFilter(state) {
  const url = new URL(window.location.href);
  const tabs = [...state.section.querySelectorAll('[data-category-tab]')];
  let tag = '';
  try {
    tag = decodeURIComponent(url.pathname.split('/tagged/')[1] || '');
  } catch (_) { /* 不正なエンコードは「すべて」として扱う */ }
  state.selectedCategory = tabs.find((tab) => tab.dataset.categoryTab === tag)?.dataset.categoryTab || '';
  syncCategoryTabs(state);

  state.selectedGenders.clear();
  state.selectedBrands.clear();
  (url.searchParams.get('gender') || '').split(',').forEach((slug) => {
    const value = GENDER_SLUG_MAP[slug.trim()];
    if (value) state.selectedGenders.add(value);
  });
  const allowedBrands = new Set([...state.section.querySelectorAll('[data-filter-brand]')].map((cb) => cb.value));
  url.searchParams.getAll('brand').map(normalizeFeatureBrand).forEach((value) => {
    if (allowedBrands.has(value)) state.selectedBrands.add(value);
  });
  state.section.querySelectorAll('[data-filter-gender]').forEach((cb) => {
    cb.checked = state.selectedGenders.has(cb.value);
  });
  state.section.querySelectorAll('[data-filter-brand]').forEach((cb) => {
    cb.checked = state.selectedBrands.has(cb.value);
  });
  const page = Number(url.searchParams.get('page'));
  state.currentPage = Number.isSafeInteger(page) && page > 0 ? page : 1;
  return state.selectedGenders.size > 0 || state.selectedBrands.size > 0;
}

function syncCategoryTabs(state) {
  state.section.querySelectorAll('[data-category-tab]').forEach((tab) => {
    const active = tab.dataset.categoryTab === state.selectedCategory;
    tab.classList.toggle('is-active', active);
    tab.setAttribute('aria-current', active ? 'page' : 'false');
  });
}

function buildFilterUrl(state, page = state.currentPage) {
  const url = new URL(window.location.href);
  url.pathname = state.blogUrl + (state.selectedCategory ? `/tagged/${encodeURIComponent(state.selectedCategory)}` : '');
  ['gender', 'brand', 'page'].forEach((key) => url.searchParams.delete(key));
  const genders = Object.entries(GENDER_SLUG_MAP).filter(([, value]) => state.selectedGenders.has(value)).map(([slug]) => slug);
  if (genders.length) url.searchParams.set('gender', genders.join(','));
  [...state.selectedBrands].sort().forEach((value) => url.searchParams.append('brand', value));
  if (page > 1) url.searchParams.set('page', String(page));
  return url;
}

function updateFilterUrl(state) {
  const url = buildFilterUrl(state);
  if (url.href !== window.location.href) window.history.pushState(null, '', url);
}

function getInitialCategory(section) {
  const activeTab = section.querySelector('[data-category-tab].is-active');
  return activeTab ? activeTab.dataset.categoryTab : '';
}

function initCategoryTabs(state) {
  const tabs = state.section.querySelectorAll('[data-category-tab]');
  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      tabs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-current', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-current', 'page');
      state.selectedCategory = tab.dataset.categoryTab;
      state.currentPage = 1;
      applyFilters(state, true);
    });
  });
}

function initFilterCheckboxes(state) {
  // 同じ value を持つ PC/SP の input をまとめて操作するため、
  // クリック時に他の同 value をシンクロ
  const attach = (selector, stateSet) => {
    state.section.querySelectorAll(selector).forEach((cb) => {
      cb.addEventListener('change', () => {
        syncCheckboxes(state.section, selector, cb.value, cb.checked);
        cb.checked ? stateSet.add(cb.value) : stateSet.delete(cb.value);
        state.currentPage = 1;
        applyFilters(state, true);
      });
    });
  };
  attach('[data-filter-gender]', state.selectedGenders);
  attach('[data-filter-brand]', state.selectedBrands);
}

function initFilterClear(state) {
  state.section.querySelectorAll('[data-filter-clear]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.section.querySelectorAll('[data-filter-gender], [data-filter-brand]').forEach((cb) => {
        cb.checked = false;
      });
      state.selectedGenders.clear();
      state.selectedBrands.clear();

      const tabs = state.section.querySelectorAll('[data-category-tab]');
      tabs.forEach((t) => {
        const isAll = t.dataset.categoryTab === '';
        t.classList.toggle('is-active', isAll);
        t.setAttribute('aria-current', isAll ? 'page' : 'false');
      });
      state.selectedCategory = '';

      state.currentPage = 1;
      applyFilters(state, true);
    });
  });
}

function syncCheckboxes(section, selector, value, checked) {
  // value は属性セレクタ経由ではなく JS 側で比較する。
  // value にダブルクオート等の特殊文字が混じっても壊れないようにするための防御策
  section.querySelectorAll(selector).forEach((c) => {
    if (c.value === value) c.checked = checked;
  });
}

async function applyFilters(state, updateUrl = false) {
  if (updateUrl) updateFilterUrl(state);
  if (state.isLoading) { state.pendingFilter = true; return; }
  state.isLoading = true;
  state.pendingFilter = false;
  const list = state.list;
  list.setAttribute('aria-busy', 'true');
  if (state.paginationContainer) state.paginationContainer.innerHTML = '';
  list.innerHTML = '<li class="c_feature-list__notice">読み込み中...</li>';

  try {
    const articles = await fetchAllArticles(state);
    const filtered = articles.filter((a) => filterFn(a, state));
    renderArticles(state, filtered);
  } catch (e) {
    const li = document.createElement('li');
    li.className = 'c_feature-list__notice';
    li.textContent = e.message;
    list.replaceChildren(li);
  } finally {
    list.removeAttribute('aria-busy');
    state.isLoading = false;
    if (state.pendingFilter) applyFilters(state);
  }
}

function filterFn(article, state) {
  // selectedCategory は「すべて」のとき空文字列 ''（タブの data-category-tab="" 由来）。
  // 空文字列なら falsy なので「カテゴリフィルタなし」として扱う。
  if (state.selectedCategory && !article.categories.includes(state.selectedCategory)) return false;
  if (state.selectedGenders.size > 0) {
    const hit = article.genders.some((g) => state.selectedGenders.has(g));
    if (!hit) return false;
  }
  if (state.selectedBrands.size > 0) {
    const hit = article.brands.some((b) => state.selectedBrands.has(b));
    if (!hit) return false;
  }
  return true;
}

function renderArticles(state, articles) {
  state.filteredArticles = articles;
  showPage(state, state.currentPage);
}

function showPage(state, page) {
  const list = state.list;
  const paginationContainer = state.paginationContainer;
  const articles = state.filteredArticles || [];

  if (articles.length === 0) {
    list.innerHTML = '<li class="c_feature-list__notice">該当する記事はありません。</li>';
    if (paginationContainer) paginationContainer.innerHTML = '';
    return;
  }

  const totalPages = Math.ceil(articles.length / state.perPage);
  state.currentPage = Math.min(Math.max(1, page), totalPages);
  page = state.currentPage;
  const pageArticles = articles.slice((page - 1) * state.perPage, page * state.perPage);

  list.innerHTML = pageArticles.map((a) => a.html).join('');

  if (!paginationContainer) return;

  paginationContainer.innerHTML = totalPages > 1 ? buildPagination(page, totalPages) : '';
  paginationContainer.querySelectorAll('[data-page]').forEach((link) => {
    link.href = buildFilterUrl(state, Number(link.dataset.page)).href;
  });
}

function initPaginationDelegate(state) {
  if (!state.paginationContainer) return;
  state.paginationContainer.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-page]');
    if (!state.filteredArticles || !btn || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    state.currentPage = Number(btn.dataset.page);
    updateFilterUrl(state);
    showPage(state, state.currentPage);
    state.section.scrollIntoView({ behavior: state.prefersReducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
  });
}

/* クライアントサイドページネーション: フィルタ適用時にJSで描画。
   c_pagination.liquid（サーバーサイド）とはHTML構造を合わせている */
function buildPagination(current, total) {
  // current/total/part は内部 state 由来の数値だが、HTML 構築時に明示的に整数化して
  // 万一文字列等が紛れた場合の HTML 注入を防ぐ
  const cur = Number(current);
  const tot = Number(total);
  const parts = getPaginationParts(cur, tot);

  const prevBtn = cur > 1
    ? `<a href="#" data-page="${cur - 1}" class="c_pagination__item c_pagination__prev" rel="prev" aria-label="前のページ">
        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 1L1 6L5 11" stroke="currentColor" stroke-width="2"/></svg>
      </a>`
    : '';

  const nextBtn = cur < tot
    ? `<a href="#" data-page="${cur + 1}" class="c_pagination__item c_pagination__next" rel="next" aria-label="次のページ">
        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1L5 6L1 11" stroke="currentColor" stroke-width="2"/></svg>
      </a>`
    : '';

  const pageItems = parts.map((part) => {
    if (part === '...') return '<span class="c_pagination__ellipsis c_font-en">...</span>';
    const n = Number(part);
    if (n === cur) return `<span class="c_pagination__item is-active" aria-current="page"><span class="c_pagination__number c_font-en">${n}</span></span>`;
    return `<a href="#" data-page="${n}" class="c_pagination__item" aria-label="${n}ページへ"><span class="c_pagination__number c_font-en">${n}</span></a>`;
  }).join('');

  return `<nav class="c_pagination" aria-label="ページネーション">${prevBtn}${pageItems}${nextBtn}</nav>`;
}

function getPaginationParts(current, total) {
  if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
  const parts = [1];
  if (current > 3) parts.push('...');
  for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
    parts.push(i);
  }
  if (current < total - 2) parts.push('...');
  parts.push(total);
  return parts;
}

async function fetchAllArticles(state) {
  if (state.cachedArticles) return state.cachedArticles;

  const fetchPage = async (page) => {
    const url = new URL(state.blogUrl, window.location.origin);
    url.searchParams.set('view', 'c_feature-data');
    url.searchParams.set('page', String(page));
    const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    const res = await fetch(url.href);
    if (!res.ok) throw new Error(`読み込みに失敗しました（${res.status}）`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc;
  };

  // 全カテゴリの軽量HTMLを取得。取得用ページ数と表示用ページ数を分ける。
  const firstPage = await fetchPage(1);
  const totalPages = Number(firstPage.querySelector('[data-feature-data]')?.dataset.pages);
  if (!Number.isSafeInteger(totalPages) || totalPages < 1) {
    throw new Error('記事を読み込めませんでした。ページを再読み込みしてください。');
  }
  const remainingPages = await Promise.all(
    Array.from({ length: totalPages - 1 }, (_, i) => fetchPage(i + 2))
  );
  const items = [firstPage, ...remainingPages].flatMap((doc) =>
    [...doc.querySelectorAll('.c_feature-list__item')]
  );

  state.cachedArticles = items.map((item) => {
    // data-* 属性は内側の <a class="c_article-item"> に出力されている
    const inner = item.querySelector('.c_article-item');
    return {
      categories: (inner?.dataset.categories || '').split(',').filter(Boolean),
      genders: (inner?.dataset.genders || '').split(',').filter(Boolean),
      brands: [...new Set([...(inner?.dataset.brands || '').split(','), ...(inner?.dataset.tags || '').split(',').filter((tag) => tag === '靴下屋fam')].filter(Boolean).map(normalizeFeatureBrand))],
      html: item.outerHTML,
    };
  });

  return state.cachedArticles;
}

function initAccordion(section) {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ANIMATION_OPTIONS = { duration: prefersReduced ? 0 : 300, easing: 'ease-out' };

  section.querySelectorAll('.c_feature-list__filter-group').forEach((details) => {
    const summary = details.querySelector('.c_feature-list__filter-summary');
    const content = details.querySelector('.c_feature-list__filter-content');
    if (!summary || !content) return;

    // 初期状態のセットアップ（open属性があれば表示、なければ高さ0）
    if (details.open) {
      details.classList.add('is-open');
    } else {
      content.style.height = '0px';
      content.style.opacity = '0';
    }

    const animate = (isOpening) => {
      if (details._accordionAnimation) {
        details._accordionAnimation.cancel();
      }

      if (isOpening) {
        details.open = true;
      }

      const fromHeight = isOpening ? 0 : content.offsetHeight;
      const toHeight = isOpening ? content.scrollHeight : 0;
      content.style.height = `${fromHeight}px`;
      content.style.opacity = isOpening ? '0' : '1';
      content.style.overflow = 'hidden';
      details.dataset.animStatus = 'running';

      const animation = content.animate(
        [
          { height: `${fromHeight}px`, opacity: isOpening ? 0 : 1 },
          { height: `${toHeight}px`, opacity: isOpening ? 1 : 0 }
        ],
        ANIMATION_OPTIONS
      );

      details._accordionAnimation = animation;

      animation.onfinish = () => {
        details.open = isOpening;
        content.style.height = isOpening ? 'auto' : '0px';
        content.style.opacity = isOpening ? '1' : '0';
        content.style.overflow = '';
        details.dataset.animStatus = '';
        details._accordionAnimation = null;
      };

      animation.oncancel = () => {
        content.style.height = details.open ? 'auto' : '0px';
        content.style.opacity = details.open ? '1' : '0';
        content.style.overflow = '';
        details.dataset.animStatus = '';
        details._accordionAnimation = null;
      };
    };

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (details.dataset.animStatus === 'running') return;
      const isOpening = !details.open;
      details.classList.toggle('is-open', isOpening);
      animate(isOpening);
    });
  });
}

function initDrawer(section) {
  const trigger = section.querySelector('[data-drawer-toggle]');
  const drawer = section.querySelector('[data-drawer-body]');
  const panel = section.querySelector('[data-drawer-panel]');
  const overlay = section.querySelector('[data-drawer-overlay]');
  const closeBtn = section.querySelector('[data-drawer-close]');
  if (!trigger || !drawer) return;

  const getFocusable = () => (panel || drawer).querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  let lastFocused = null;

  const handleKeydown = (e) => {
    if (e.key === 'Escape') {
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusable = [...getFocusable()];
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  const open = () => {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeydown);
    const focusable = getFocusable();
    if (focusable.length) focusable[0].focus();
  };

  const close = () => {
    drawer.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleKeydown);
    if (lastFocused) lastFocused.focus();
  };

  trigger.addEventListener('click', open);
  if (overlay) overlay.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);
}

document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.c_feature-list');
  if (section) initSection(section);
});
document.addEventListener('shopify:section:unload', () => {
  // ドロワーが開いた状態で unload されると body.overflow が hidden のまま残る
  document.body.style.overflow = '';
});
})();
